import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroBanners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % heroBanners.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent(p => (p - 1 + heroBanners.length) % heroBanners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = heroBanners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroBanners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={b.bgImage}
            alt={b.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-2xl">
            <span className="inline-block bg-accent-500 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4">
              热门推荐
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
              {banner.title}
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-8 max-w-lg">
              {banner.subtitle}
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/comic/${banner.comicId}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                立即阅读
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
              >
                浏览全部
                <i className="ri-apps-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm text-white flex items-center justify-center hover:bg-white/35 transition-all cursor-pointer whitespace-nowrap"
        aria-label="Previous banner"
      >
        <i className="ri-arrow-left-s-line text-lg w-5 h-5 flex items-center justify-center"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm text-white flex items-center justify-center hover:bg-white/35 transition-all cursor-pointer whitespace-nowrap"
        aria-label="Next banner"
      >
        <i className="ri-arrow-right-s-line text-lg w-5 h-5 flex items-center justify-center"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroBanners.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`Go to banner ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}